/* eslint-disable @typescript-eslint/no-explicit-any */
import { IEvent, IEventsPagination } from '@interfaces/IEvent';
import { IFormErrors } from '@interfaces/IFormsErrors';

export interface IEventsViewState {
  events: IEvent[] | null;
  //TODO Альбина должна переделать и убрать any. Чтобы когда убрать eslint-disable линтер не ругался
  event: any | null;
  pagination: IEventsPagination | null;
  isLoading: boolean;
  errors: IFormErrors | null;
  currentEvent: IEvent | null;
}

export const initialEventsViewState: IEventsViewState = {
  events: null,
  event: null,
  pagination: null,
  isLoading: false,
  errors: null,
  currentEvent: null,
};
